import SwipeListener from 'swipe-listener';
import createFocusTrap from 'focus-trap';
import NavBase from './base';
import {enableBodyScroll, disableBodyScroll} from 'body-scroll-lock';

const namespace = 'header-mobile';
const focusable = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
const $ = jQuery;

export default class NavMobile extends NavBase
{
    init(){
        this.isSetup = false;
        this.$subnav = this.$el.find('.header-nav__subnav');
        this.$bd = $(document.body);
        this.$offcanvas = $('.off-canvas');
        this.$offcanvasBg = this.$offcanvas.find('.off-canvas__bg');
        this.$content = this.$offcanvas.find('.off-canvas__content');
        this.$main = this.$content.find('.off-canvas__content-body');
        this.focusTrap = createFocusTrap( this.$content[0] );
        this.onInputChange = (v) => this.updateSearch(v);
    }

    setup(){
        // skip if we've already done setup
        if( this.isSetup ){
            return;
        }
        // if(1){
        //     for(var i=0;i < 80; i++){
        //         this.$main.append( $('<p>Test</p>') );
        //     }
        //     this.isSetup = true;
        //     return;
        // }
        const $source = $('.header-nav').clone();
        // lets convert all small columns to large columns
        $source.find('[class*="col-sm"]').each(function(i, el){
            el.className = el.className.replace(/col-sm/, 'col-lg');
        });
        // remove the "X" that is in the main menu
        $source.find('span.mdi-close').remove();

        // add the off-canvas menu
        this.$menu = $('<div class="offcanvas-menu" data-show="0" />').appendTo( this.$main );
        this.$panels = jQuery([
            $('<div />').addClass('offcanvas-menu__panel').attr('data-level', '0').appendTo(this.$menu)[0],
            $('<div />').addClass('offcanvas-menu__panel').attr('data-level', '1').appendTo(this.$menu)[0],
            $('<div />').addClass('offcanvas-menu__panel').attr('data-level', '2').appendTo(this.$menu)[0]

        ]);
        this.$nav = $source.find('.header-nav__primary .header-nav__menu');
        this.$nav.removeClass('header-nav__menu').addClass('-big-links');
        this.$nav.find('>li:not(.desktop-only)').each((i,el) => {
            
            const menu = $(el).data('menu');
            const $a = $(el).find('>a').first();
            $a.attr('data-subnav', menu);
            $a.find('.mdi').remove();
            const title = $a.text();
            const $sub = $source.find(`.header-nav__subnav .header-subnav[data-menu="${menu}"] .header-subnav__primary`);
            if( $sub.length ){
                $sub.addClass('-big-links');
                const $div = $('<div />').addClass('subnav').attr('data-id', menu);
                // we need a "back button"
                const $heading = $('<div />').addClass('subnav-heading');
                const $back = $('<a href="#" />').addClass('back-button').html('<span class="mdi mdi-arrow-left"></span> Back');
                $heading.append( $back );
                $('<span />').html( title ).appendTo( $heading );
                $div.append( $heading );
                $div.append( $sub );
                const $default = $source.find(`[data-id="${menu}_default"]`);
                if( $default.length ){
                    $default.addClass( 'container' );
                    $div.append( $default );
                }
                this.$panels.eq(1).append( $div );
                // tertiary time
                $sub.find('>li').each((j, el) => {
                    
                    const target = $(el).find('>a').data('target');
                    if( !target || target.match(/_default$/) ){
                        return;
                    }
                    const $tertiary = $source.find( `[data-id="${target}"]` );
                    $(el).find('>a').attr('data-subnav', target );
                    if( $tertiary.length ){
                        const $ct = $('<div />').addClass( 'subnav' ).attr('data-id', $tertiary.attr('data-id') );
                        const $heading = $('<div />').addClass('subnav-heading');
                        const $back = $('<a href="#" />').addClass('back-button').html('<span class="mdi mdi-arrow-left"></span> Back');
                        $heading.append( $back );
                        $tertiary.find('a.header-subnav__heading').first().appendTo( $heading );
                        $ct.prepend($heading);
                        this.$panels.eq(2).append($ct);
                        $ct.append( $tertiary.find('.header-subnav__secondary-nav').addClass('-big-links') );
                        $tertiary.find( '.header-subnav__secondary-user-content' ).addClass('container').appendTo( $ct );
                    }
                });

            }
        });
        this.$nav.find('.desktop-only').remove();
        this.$nav.find('.header-nav')
        this.$nav.appendTo( this.$panels.first() );
        const $utility = $('.header-brand__nav').clone();

        const $ul = $utility
            .find('ul').first().addClass('-big-links header-utility-menu')

        $utility.find('li').appendTo($ul)
        $ul.appendTo( this.$panels.first() );
        
        this.isSetup = true;
    }

    scrollIntoView(){
        const y = $('header.page-header')[0].getBoundingClientRect().y;

        if( y ){
            window.scrollTo({
             top: y,
             behavior: 'instant'
            })
        }
    }

    enable(){
        this.menuOpen = false;
        this.setup();
        this.$offcanvas.show();

        // copy the actual search form to the header
        this.$el.find('.header-search .wp-search-form').appendTo( this.$content.find('.off-canvas__search') );
        this.$main.append( this.header.searchComponent.$el );

        this.header.searchComponent.$on('input', this.onInputChange);

        $(document).on(`click.${namespace}`, '[data-toggle="offcanvas"]', e => this.toggleMenu() );
        $(window).on(`resize.${namespace}`, () => this.updateHeight() );
        this.$main.on(`click.${namespace}`, 'a[data-subnav]', (e) => this.clickItem(e) );
        this.$main.on(`click.${namespace}`, 'a.back-button', (e) => this.clickBack(e) );
        this.$offcanvasBg.on(`click.${namespace}`, () => {
            if( this.cancelClick ){
                this.cancelClick = false;
                return;
            }
            this.close()
        } );
    }

    disable(){
        this.$content.find('.off-canvas__search .wp-search-form').appendTo( this.$el.find('.header-search') );
        
        this.$el.find('.header-search-results').append( this.header.searchComponent.$el );

        $(document).off(`.${namespace}`);
        $(window).off(`.${namespace}`);
        this.$offcanvasBg.off(`.${namespace}`);
        this.close();
        this.$offcanvas.hide();
    }

    toggleMenu( on ){
        if( this.cancelToggle ){
            this.cancelToggle = false;
            return;
        }
        if( on === undefined ){
            on = !this.menuOpen;
        }
        if( on ){
            this.open();
        }
        else {
            this.close();
        }
    }

    updateHeight(){
        const offset = jQuery('.page-header').offset().top  - window.pageYOffset;
        const h = window.innerHeight - offset;
        this.$offcanvas.attr('style', `height: ${h}px;`);
    }

    open(){
        if( this.menuOpen ){
            return;
        }
        this.scrollIntoView();
        this.updateHeight();
        this.$menu.attr('data-show', '0');
        this.$panels.eq(0).scrollTop(0);
        $('body').addClass('-offcanvas-open');
        this.swipeListener = new SwipeListener( document.body, {
            minHorizontal : 10
        });
        $(document.body).on( `swiping.${namespace}-swipe`, e => this.swiping(e) );
        $(document.body).on( `swipe.${namespace}-swipe`, e => this.swipe(e) );
        $(document.body).on( `swipecancel.${namespace}-swipe`, e => this.swipeCancel(e) );
        this.$panels.each( function(){
            disableBodyScroll( this, {
                reserveScrollBarGap: true
            } );
        });
        disableBodyScroll( this.header.searchComponent.$el, { reserveScrollBarGap: true } );
        $(window).on(`keydown.${namespace}`, e => this.onKeyPress(e) );
        setTimeout(() => {
            this.focusTrap.activate();
            this.$main.find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])').filter(':visible').not('.back-button').first().focus();
        }, 300 );
        this.menuOpen = true;
    }

    close(){
        
        this.$content.css({
            'transform':''
        });
        this.$offcanvasBg.css({
            'opacity': ''
        });
        if( !this.menuOpen ){
            return;
        }
        this.$panels.each( function(){
            enableBodyScroll( this );
        });
        enableBodyScroll( this.header.searchComponent.$el );
        // enableBodyScroll( this.$main[0] );
        $('body').removeClass('-offcanvas-open');
        $(document.body).off( `.${namespace}-swipe`);
        $(window).off(`keydown.${namespace}`);
        this.$menu.attr('data-show', 0);
        this.menuOpen = false;
        this.focusTrap.deactivate();
        
    }

    onKeyPress( e ){
        if( e.which === 27 ){
            this.close()
        }
    }

    updateSearch(v){
        this.$offcanvas.toggleClass('-display-search',v!=='');
    }

    swiping(e){
        this.cancelClick = true;
        const diff = e.detail.x[1] - e.detail.x[0];
        if( diff > 0 ){
            const w = this.$content.outerWidth();
            const px = w - diff;
            const percent = diff/w;
            this.$content.addClass('-swiping');
            this.$content.css({
                'transform':`translate3d( -${px}px, 0, 0)`
            });
            this.$offcanvasBg.addClass('-swiping');
            this.$offcanvasBg.css({
                'opacity' : (0.7 * (1-percent))
            });
        }
        else {
            this.$content.css({
                'transform':'translate3d(-100%,0,0)'
            });
        }
    }

    swipe(e){
        
        this.$content.css({
            'transform':''
        });
        this.$offcanvasBg.css({
            'opacity': ''
        });
        this.$content.removeClass('-swiping');
        this.$offcanvasBg.removeClass('-swiping');
        if( e.detail.directions.right ){
            this.close();
        }
        else {
            this.$panels.each( function(){
                disableBodyScroll( this );
            });
            disableBodyScroll( this.header.searchComponent.$el );
        }
        
    }

    swipeCancel(e){
        this.$content.removeClass('-swiping');
        this.$offcanvasBg.removeClass('-swiping');
        this.$content.css({
            'transform':''
        });
        this.$offcanvasBg.css({
            'opacity': ''
        });
        this.$panels.each( function(){
            disableBodyScroll( this );
        });
        disableBodyScroll( this.header.searchComponent.$el );
    }

    clickItem(e){
        e.preventDefault();
        const target = $(e.currentTarget).data('subnav');
        // find the subnav
        const $subnav = $(`.subnav[data-id="${target}"]`);
        const $panel = $subnav.closest('.offcanvas-menu__panel');

        $panel.find('.subnav').not( $subnav ).removeClass('-active');
        $subnav.addClass('-active');
        $panel.scrollTop(0);
        $panel.closest('.offcanvas-menu').attr('data-show', $panel.data('level') );
        setTimeout(() => {
            $panel.find( focusable ).filter( ':visible' ).not( '.back-button' ).first().focus();
        }, 300 );
    }

    clickBack(e){
        e.preventDefault();
        const i = Number( this.$menu.attr('data-show') ) - 1;
        this.$menu.attr('data-show', i );
        setTimeout(() => {
            this.$panels.eq(i).find( focusable ).filter(':visible').not('.back-button').first().focus();
        }, 300);
    }
}